import { ToolUsageGroup } from "./tool-usage-group.model";
import { RevisionInfo } from "@components/revision-info/models/revision-info.model";

export class ToolUsage {
    public toolId: number;
    public toolUid: string;
    public toolName: string;
    public toolStatus: string;
    public toolStance: string;
    public toolDetailsId: number;
    public lineName: string;
    public cleaningPercentage: number;
    public maintenancePercentage: number;
    public measurementsPercentage: number;
    public ticketId: number;
    public closestCleaningRecurrenceName: string;
    public closestMaintenanceRecurrenceName: string;
    public closestMeasurementsRecurrenceName: string;
    public parent: ToolUsageGroup;
    public revisionInfo: RevisionInfo;

    constructor(toolUsage: any = {}) {
        this.toolId = toolUsage.toolId;
        this.toolUid = toolUsage.toolUid;
        this.toolName = toolUsage.toolName;
        this.toolStatus = toolUsage.toolStatus;
        this.toolStance = toolUsage.toolStance;
        this.toolDetailsId = toolUsage.toolDetailsId;
        this.lineName = toolUsage.lineName;
        this.cleaningPercentage = toolUsage.cleaningPercentage || 0;
        this.maintenancePercentage = toolUsage.maintenancePercentage || 0;
        this.measurementsPercentage = toolUsage.measurementsPercentage || 0;
        this.closestCleaningRecurrenceName = toolUsage.closestCleaningRecurrenceName;
        this.closestMaintenanceRecurrenceName = toolUsage.closestMaintenanceRecurrenceName;
        this.closestMeasurementsRecurrenceName = toolUsage.closestMeasurementsRecurrenceName;
        this.ticketId = toolUsage.ticketId;
        this.revisionInfo = toolUsage.revisionInfo ? new RevisionInfo(toolUsage.revisionInfo) : null;
    }

    public getBackgroundColor(value: number) {
        if (value < 75) {
            return 'bg-success';
        }
        if (value < 90) {
            return 'bg-warning'
        }
        return 'bg-danger';
    }
}
